import {
  DragDropActionTypes,
  useDragDropContext,
} from "../../../../utilities/drag-drop";
import { PageItemType, useEditTile } from "../../../../utilities/layout";
import { CommonQuickKeyProps } from "../DynamicQuickKeyList/types";
import { QuickKeyProps } from "../QuickKey";
import { InteractivityWrapper } from "./components";

export type InteractiveQuickKeyProps = Omit<QuickKeyProps, "onPress"> &
  CommonQuickKeyProps & {
    beforeDrag?(): void;
  };

export const InteractiveQuickKey = ({
  item,
  beforeDrag,
  draggable = true,
  droppable,
  children,
}: InteractiveQuickKeyProps) => {
  const { openEditTile } = useEditTile();

  const {
    controllers: { animationController },
    draggingComponentRef,
    performLayoutAction,
  } = useDragDropContext();

  function handleDrop(droppedItem: PageItemType) {
    performLayoutAction({
      type: DragDropActionTypes.SHIFT_POS_LAYOUT_KEYS,
      payload: {
        id: droppedItem?.id,
        position: item.position,
      },
    });
  }

  function handleEnter() {
    const id = draggingComponentRef.current?.data?.config.id;
    if (id) {
      animationController.shift(id, item.position);
    }
  }

  function handleLeave() {
    if (!draggingComponentRef.current) return;
    animationController.restorePositions();
  }

  function handlePress() {
    if (!item.config) return;
    openEditTile(item);
  }

  return (
    <InteractivityWrapper
      onPress={handlePress}
      onDrop={handleDrop}
      onEnter={handleEnter}
      onLeave={handleLeave}
      item={item}
      dragging={!!draggingComponentRef.current}
      draggable={draggable}
      droppable={droppable}
    >
      {children}
    </InteractivityWrapper>
  );
};
